<app-todo *ngIf="move" [label]="i18nKeys.Todo | translate : { name: move | userName }" [state]="move.track.transferee.energyInviteSent">
    <app-todo-template *todoStateChecked>
        <a app-button *ngIf="canResend" (click)="resendConfirm()" [appearance]="buttonAppearance.Link" [size]="buttonSize.Sm">{{
            i18nKeys.Resend | translate
        }}</a>
        <span>{{ move.track.lastModifiedOn.energyInviteSent | formatDate }}</span>
    </app-todo-template>
</app-todo>
